import React from 'react'
import useContentfulVariation from '@/hooks/useContentfulVariation'
import { CustomMerchModule, CustomToutType } from '@/types'
import MerchModuleWrapper from '../../MerchModuleWrapper'

export default function MarketingTout() {
  const marketingTout = useContentfulVariation<
    CustomToutType | CustomMerchModule
  >('marketingTout')

  return marketingTout != null ? (
    <MerchModuleWrapper content={marketingTout} />
  ) : null
}
